import React from "react"

import { position } from "./jobDescription.module.css"

const JobDescription = ({ children }) => {
  return <div className={position}>{children}</div>
}

export default JobDescription
